import AcceptTermsAndConditionsPage from "./acceptTermsAndConditions";

export default AcceptTermsAndConditionsPage;